import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';
import type { ReactNode } from 'react';

export type MicrosoftIconProps = SvgIconProps;

export function MicrosoftIcon(props: MicrosoftIconProps): ReactNode {
  return (
    <SvgIcon viewBox="0 0 21 21" {...props}>
      <rect x="1" y="1" width="9" height="9" fill="#F25022" />
      <rect x="11" y="1" width="9" height="9" fill="#7FBA00" />
      <rect x="1" y="11" width="9" height="9" fill="#00A4EF" />
      <rect x="11" y="11" width="9" height="9" fill="#FFB900" />
    </SvgIcon>
  );
}
